module.exports = __webpack_public_path__ + "static/media/demo-article-hero.8f1798f4.jpg";